import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, assetUrl } from "@/lib/api";
import { useDraft } from "@/components/import/DraftContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ImagePicker({ open, onClose, onPick, title }) {
  const { id } = useDraft();
  const [q, setQ] = useState("");
  const [all, setAll] = useState(false);
  const { data } = useQuery({
    queryKey: ["imports", id, "images", "picker", q, all], enabled: open,
    queryFn: () => api.get(`/imports/${id}/images`, { params: { status: all ? "all" : "unassigned", q: q || undefined, page_size: 120 } }).then((r) => r.data),
  });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] max-w-3xl overflow-y-auto border-[#2A3447] bg-[#121620] text-slate-200" data-testid="import-image-picker">
        <DialogHeader><DialogTitle className="font-heading text-amber-100">{title}</DialogTitle></DialogHeader>
        <div className="flex flex-wrap items-center gap-3">
          <input className="field min-w-0 flex-1" placeholder="Search file names" value={q} onChange={(e) => setQ(e.target.value)} data-testid="import-picker-search" />
          <label className="flex items-center gap-2 text-xs text-slate-400">
            <input type="checkbox" checked={all} onChange={(e) => setAll(e.target.checked)} data-testid="import-picker-all" />Include assigned images
          </label>
        </div>
        {!data?.items?.length ? <p className="py-8 text-center text-sm text-slate-500" data-testid="import-picker-empty">No images. Upload them in the Images tab.</p> : (
          <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
            {data.items.map((img) => (
              <button key={img.file_id} onClick={() => onPick(img.file_id)} className="group text-left" data-testid={`import-picker-${img.file_id}`}>
                <img src={assetUrl(img.url)} alt={img.filename} className="aspect-[63/88] w-full rounded border border-[#2A3447] bg-black/40 object-contain transition-[border-color] group-hover:border-amber-400" />
                <p className="mt-1 truncate font-mono text-[10px] text-slate-400">{img.filename}</p>
                {img.assigned.length > 0 && <p className="font-mono text-[10px] text-amber-400">in use</p>}
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
